import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import INITIAL_FILTERS from '@app/constants/editingDocumentsFilterInitialValues';
import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_FILE_DOWNLOAD_FAILURE,
  EDITING_DOCUMENTS_FILE_DOWNLOAD_REQUEST,
  EDITING_DOCUMENTS_FILE_DOWNLOAD_SUCCESS,
  EDITING_DOCUMENTS_LIST_DELETE_FAILURE,
  EDITING_DOCUMENTS_LIST_DELETE_REQUEST,
  EDITING_DOCUMENTS_LIST_DELETE_SUCCESS,
  EDITING_DOCUMENTS_LIST_FETCH_FAILURE,
  EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import EditingDocument from '@app/store/editingDocuments/EditingDocument';

export function editingDocumentsListDeleteRequest(payload: string[]) {
  return {
    type: EDITING_DOCUMENTS_LIST_DELETE_REQUEST,
    payload,
  };
}

export function editingDocumentsListDeleteSuccess() {
  return {
    type: EDITING_DOCUMENTS_LIST_DELETE_SUCCESS,
  };
}

export function editingDocumentsListDeleteFailure(payload: AxiosError) {
  return {
    type: EDITING_DOCUMENTS_LIST_DELETE_FAILURE,
    payload,
    error: true,
  };
}

export function editingDocumentsListFetchRequest(payload: {
  limit: number;
  offset: number;
  searchKeyword: string;
  memberId: string | null;
}) {
  return {
    type: EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
    payload,
  };
}

export function editingDocumentsListFetchSuccess(payload: {
  limit: number;
  editingDocuments: EditingDocument[];
  maxPage: number;
  offset: number;
  searchKeyword: string;
  totalCount: number;
  memberId: string | null;
}) {
  return {
    type: EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
    payload,
  };
}

export function editingDocumentsListFetchFailure(payload: AxiosError) {
  return {
    type: EDITING_DOCUMENTS_LIST_FETCH_FAILURE,
    payload,
    error: true,
  };
}

export function editingDocumentsFileDownloadRequest(editingDocumentId: string, title: string) {
  return {
    type: EDITING_DOCUMENTS_FILE_DOWNLOAD_REQUEST,
    payload: { editingDocumentId, title },
  };
}

export function editingDocumentsFileDownloadSuccess() {
  return {
    type: EDITING_DOCUMENTS_FILE_DOWNLOAD_SUCCESS,
  };
}

export function editingDocumentsFileDownloadFailure() {
  return {
    type: EDITING_DOCUMENTS_FILE_DOWNLOAD_FAILURE,
    error: true,
  };
}

export function initializeEditingDocumentDomainData() {
  return {
    type: EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  };
}

export type EditingDocumentsAction =
  | ReturnType<typeof editingDocumentsListDeleteRequest>
  | ReturnType<typeof editingDocumentsListDeleteSuccess>
  | ReturnType<typeof editingDocumentsListDeleteFailure>
  | ReturnType<typeof editingDocumentsListFetchRequest>
  | ReturnType<typeof editingDocumentsListFetchSuccess>
  | ReturnType<typeof editingDocumentsListFetchFailure>
  | ReturnType<typeof editingDocumentsFileDownloadRequest>
  | ReturnType<typeof editingDocumentsFileDownloadSuccess>
  | ReturnType<typeof editingDocumentsFileDownloadFailure>
  | ReturnType<typeof initializeEditingDocumentDomainData>;

export const refetchEditingDocumentList = createAsyncThunk(
  'editingDocuments/refetch',
  (_args, { dispatch }) => {
    dispatch(initializeEditingDocumentDomainData());
    dispatch(editingDocumentsListFetchRequest(INITIAL_FILTERS));
  }
);
